//通用页尾模块
import React, {Component} from 'react';

class Footer extends Component {
    render() {
        const year = (new Date()).getFullYear();
        return (
            <footer>
                <div className="box">
                    <div className="links">
                        {/* <a href="https://en.bestwehotel.com/aboutUs">About Us</a> */}
                        {/* <a href="https://en.bestwehotel.com/contactUs">Contact Us</a> */}
                        <span>Contact Us</span>
                    </div>
                    <div className="phone"><i></i>400-820-9999</div>
                    <div className="copyright">WeHotel Co.,Ltd Copyright© 2016 - {year} en.bestwehotel.com All Rights</div>
                </div>
            </footer>
        );
    }
}

export default Footer;